import React from "react";
import { useBmapi } from "../../utils/bmapi-context";
import { Container } from "@material-ui/core";
import ReportCreateForm from "../../ui/forms/ReportCreateForm";
import "react-quill/dist/quill.snow.css";
import { MANAGER_ROUTES } from "../../utils/constants";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { getErrorMessageString } from "../../utils/errors";
import Title from "../../ui/Title";
import { jsc } from "../../messages";

function ReportBuilder() {
  const { bmapi, notifySuccess, notifyError } = useBmapi();
  const intl = useIntl();
  const history = useHistory();

  function handleBack() {
    history.push(MANAGER_ROUTES.REPORT_INSPECTION);
  }

  function onSubmit(data) {
    let link_attachments = data.report_attachments;
    delete data.report_attachments;
    bmapi
      .saveReport(data)
      .then((res) => {
        uploadFiles(res, link_attachments);
      })
      .then(() => {
        setTimeout(goToInspection, parseFloat(link_attachments.length) * 1000);
      })
      .catch((e) => {
        notifyError(getErrorMessageString(e, intl));
      });
  }

  function uploadFiles(res, link_attachments) {
    if (bmapi) {
      link_attachments?.map((option) => {
        bmapi
          .addMediaContent(res.id, option.name, option, "Report")
          .then(() => {
            notifySuccess(intl.formatMessage(jsc.reportCreate));
          })
          .catch((e) => {
            notifyError(getErrorMessageString(e, intl));
          });
      });
    }
  }

  function goToInspection() {
    window.location.href = MANAGER_ROUTES.REPORT_INSPECTION;
  }

  return (
    <div className="p-2 bg-white">
      <Container maxWidth="sm" className="tablistNone">
        <Title>{intl.formatMessage(jsc.reportCreation)}</Title>
        <ReportCreateForm
          handleBack={handleBack}
          handleSubmit={onSubmit}
          style={{ background: "red" }}
        />
      </Container>
    </div>
  );
}

export default ReportBuilder;
